import { ChatMessage as UsecaseReduxChatMessage } from '~/domain/usecases/chat/redux';
import { ReduxChatMessage } from '~/data/store/reducer/chat/usecases';

export const makeReduxChatMessage = (): UsecaseReduxChatMessage =>
  new ReduxChatMessage();
